module.exports = __webpack_public_path__ + "img/bg_new.29c7beb5.png";